module.exports = __webpack_public_path__ + "img/txtImg.54a39a33.png";